export default "__VITE_ASSET__BMA_o3Ih__"